export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-4 border-b border-border pb-5 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function EmptyState({ title = "No records yet", hint, icon: Icon, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center" data-testid="empty-state">
      {Icon && <Icon className="h-10 w-10 text-muted-foreground/50" strokeWidth={1.5} />}
      <div>
        <p className="font-display text-lg font-semibold">{title}</p>
        {hint && <p className="mt-1 text-sm text-muted-foreground">{hint}</p>}
      </div>
      {action}
    </div>
  );
}

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-muted-foreground" data-testid="loading-state">
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      {label}…
    </div>
  );
}
